module.exports = __webpack_public_path__ + "static/media/download.7163c293.pdf";